import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getWorkorder = async (params) => {
    try {
  return await get<ApiResponse<[]>>(`/workorder?${params}`).then((res)=> {
    if(res?.success===true) {
        return res
    }
    else {
        HandleApiError(res.error.msg)
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
